import { EMemoryType } from '@/service/note';

export function isShortVoiceNote(obj: Record<string, any>): boolean {
  return obj.memoryType === EMemoryType.SHORT_AUDIO;
}
